import React, { ReactElement, useEffect, useMemo, useState } from "react";
import { Controller, SwiperOptions } from "swiper";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
//import type SwiperClass from "swiper/types/swiper-class";
import { Tab } from "../Tabs/Tab";
import styles from "./TabsSlider.module.scss";

export interface TabsSliderProps {
  tabs: ReactElement[];
  slides: ReactElement[];
  activeSlideIndex?: number;
}

const swiperTabsConfig: SwiperOptions = {
  autoHeight: true,
  a11y: { enabled: true },
  slidesPerView: "auto", //5, // Slides Visible in Single View Default is 1

  centeredSlides: true,
  shortSwipes: true,
  longSwipes: true,
  loop: false,
  loopedSlides: 4,
  preventInteractionOnTransition: true,
  observer: true,
  keyboard: true,
  slideToClickedSlide: true,
  freeMode: true,

  spaceBetween: 0 // Space between each Item
  // breakpoints: {
  //   //MD
  //   768: {
  //     spaceBetween: 24
  //   },
  //   //LG
  //   1024: {
  //     spaceBetween: 24
  //   },
  //   //XL
  //   1280: {
  //     spaceBetween: 32
  //   }
  // }
};

const swiperSlidesConfig: SwiperOptions = {
  a11y: { enabled: true },
  slidesPerView: 1, // Slides Visible in Single View Default is 1
  spaceBetween: 16, // Space between each Item
  centeredSlides: true,
  preventInteractionOnTransition: true,
  shortSwipes: true,
  longSwipes: true,
  loop: false,
  loopedSlides: 4,
  observer: true,
  freeMode: false
};

export const TabsSlider: React.FC<React.PropsWithChildren<TabsSliderProps>> = ({
  tabs,
  slides,
  activeSlideIndex
}) => {
  const [firstSwiper, setFirstSwiper] = useState<SwiperClass | undefined>(
    undefined
  );
  const [secondSwiper, setSecondSwiper] = useState<SwiperClass | undefined>(
    undefined
  );

  useEffect(() => {
    if (activeSlideIndex) firstSwiper?.slideTo(activeSlideIndex);
  }, [firstSwiper, activeSlideIndex]);

  const tabsWithProps = useMemo(
    () =>
      React.Children.map(tabs, (child, index) => {
        if (React.isValidElement(child)) {
          return (
            <SwiperSlide virtualIndex={index}>
              {({ isActive }) => (
                <Tab color="titanium" underline selected={isActive}>
                  {child}
                </Tab>
              )}
            </SwiperSlide>
          );
        }
      }),
    [tabs]
  );

  const slidesWithProps = useMemo(
    () =>
      React.Children.map(slides, (child, index) => {
        if (React.isValidElement(child)) {
          return <SwiperSlide virtualIndex={index}>{child}</SwiperSlide>;
        }
      }),
    [slides]
  );

  return (
    <div className={styles.container}>
      <Swiper
        className={styles.tabsSlider}
        {...swiperTabsConfig}
        modules={[Controller]}
        onSwiper={setFirstSwiper}
        controller={{ control: secondSwiper }}
      >
        {tabsWithProps}
      </Swiper>
      <Swiper
        className={styles.slidesSlider}
        {...swiperSlidesConfig}
        modules={[Controller]}
        onSwiper={setSecondSwiper}
        controller={{ control: firstSwiper }}
        //thumbs={{ swiper: firstSwiper }}
      >
        {slidesWithProps}
      </Swiper>
    </div>
  );
};
